export const getPermissionsManagerUrlToUse = (userId: string) => {
  return `/landing/nxlambda/userPermissionsManager/${userId}`;
};

export const getAddPermissionsUrlToUse = (
  userId: string,
  permissionGroup: string
) => {
  return `/landing/nxlambda/userPermissionsManager/add/${userId}/${permissionGroup}`;
};

export const getRemovePermissionsUrlToUse = (
  userId: string,
  permissionGroup: string
) => {
  return `/landing/nxlambda/userPermissionsManager/remove/${userId}/${permissionGroup}`;
};

export const getPermissionGroupsUrlToUse = () => {
  return `/landing/nxlambda/userPermissionsManager`;
};
